type DataType = {
	title: string;
	'label-value': { label: string; value: string }[];
};

export const injury: DataType = {
	title: 'Injury Level',
	'label-value': [
		{ value: '', label: 'Any Level' },
		{ value: 'c1', label: 'C1' },
		{ value: 'c2', label: 'C2' },
		{ value: 'c3', label: 'C3' },
		{ value: 'c4', label: 'C4' },
		{ value: 'c5', label: 'C5' },
		{ value: 'c6', label: 'C6' },
		{ value: 'c7', label: 'C7' },
		{ value: 'c8', label: 'C8' },
		{ value: 't1', label: 'T1' },
		{ value: 't2', label: 'T2' },
		{ value: 't3', label: 'T3' },
		{ value: 't4', label: 'T4' },
		{ value: 't5', label: 'T5' },
		{ value: 't6', label: 'T6' },
		{ value: 't7', label: 'T7' },
		{ value: 't8', label: 'T8' },
		{ value: 't9', label: 'T9' },
		{ value: 't10', label: 'T10' },
		{ value: 't11', label: 'T11' },
		{ value: 't12', label: 'T12' },
		{ value: 'l1', label: 'L1' },
		{ value: 'l2', label: 'L2' },
		{ value: 'l3', label: 'L3' },
		{ value: 'l4', label: 'L4' },
		{ value: 'l5', label: 'L5' },
		{ value: 's1', label: 'S1' },
		{ value: 's2', label: 'S2' },
		{ value: 's3', label: 'S3' },
		{ value: 's4', label: 'S4' },
		{ value: 's5', label: 'S5' },
		// ...Object.entries(levels).map(([key, value]) => ({
		// 	label: key.toUpperCase(),
		// 	value: value,
		// })),
	],
};

export const severity: DataType = {
	title: 'Severity',
	'label-value': [
		{ value: '', label: 'Any' },
		{ value: 'a', label: 'AIS-A' },
		{ value: 'b', label: 'AIS-B' },
		{ value: 'c', label: 'AIS-C' },
		{ value: 'd', label: 'AIS-D' },
		// ...Object.entries(asia).map(([key, value]) => ({
		// 	label: `AIS-${key.toUpperCase()}`,
		// 	value: value,
		// })),
	],
};

export const time: DataType = {
	title: 'Time Since Injury',
	'label-value': [
		{ label: 'Any', value: '' },
		{ label: 'Sub-Acute ( < 6 months)', value: 'subacute' },
		{ label: 'Acute ( < 72 hours)', value: 'acute' },
		{ label: 'Chronic ( > 6 months)', value: 'chronic' },
	],
};
